import { progressTypes } from "constants/action-types";

export const SMART_ORDERS = {
    FETCH: progressTypes("SMART_ORDERS"),
};
